
define('text!areas/home/views/placeholder.html',[],function () { return '<section id="placeholder">\r\n</section>';});

